import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-heatwave-sidebar',
  templateUrl: './heatwave-sidebar.component.html',
  styleUrls: ['./heatwave-sidebar.component.scss']
})
export class HeatwaveSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  isInitialLoad: boolean = false;
  selected: string;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  sourceOptions: any = ['IMD', 'ECMWF'];
  selectedSource: any;
  sourceMapping = {
    'IMD': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF'
  }
  modalRef: any;
  queryParams: any;
  isChecked: boolean = false;
  enableSchoolAlert: boolean = false;
  enableAnganwadi: boolean = false;
  enableHealthCare: boolean = false;
  isCheckedAnganwadi: boolean = false;
  isCheckedHealthCare: boolean = false;

  constructor(public gisUtils: UtilsService, private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private toastr: ToastrService
  ) {
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.selectedSource = this.queryParams['source'] == 'IMD_LONG_RANGE' ? 'IMD' : 'ECMWF'
        if (this.blockNum == 3) {
          this.dateIndexLength = this.selectedSource == 'IMD' ? 10 : 46
        } else {
          this.dateIndexLength = this.selectedSource == 'IMD' ? 9 : 45
        }
        for (let i = 0; i < this.dateIndexLength; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
        this.requestSelectedFilterParams()
        if (this.queryParams.locType == 'DISTRICT') {
          this.enableSchoolAlert = true
          this.enableAnganwadi = true
          this.enableHealthCare = true
        } else {
          this.resetVariables()
        }
      }
    });
  }

  resetVariables() {
    this.isChecked = false
    this.isCheckedAnganwadi = false
    this.isCheckedHealthCare = false
    this.enableSchoolAlert = false
    this.enableAnganwadi = false
    this.enableHealthCare = false
    this.gisUtils.schoolCheckBoxClicked.next(false)
    this.gisUtils.CheckBoxAngaClicked.next(false)
    this.gisUtils.CheckBoxHealthCareClicked.next(false)
  }

  ngOnChanges(change: SimpleChanges) {
    let timeStamp = this.labelStrings[this.blockNum].groupName;
    this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
      if(this.selectedSource == 'ECMWF') {
        this.gisUtils.setPlayButton(blockNumber)
      }
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, { backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent' })
    this.modalRef.componentInstance.selected = value;
  }

  reloadFunction() {
    let tsArray = this.gisUtils.get10DaysTimeStamps();
    let curTimeStamp = new Date().getTime()
    let curInterval = tsArray['0'] - curTimeStamp;
    setTimeout(function () {
      window.location.reload();
    }, curInterval);
  }

  sourceChange() {
    // this.gisUtils.setHeatWaveSource.next(this.sourceMapping[this.selectedSource]);
    let options = { ...this.queryParams }
    options['source'] = this.sourceMapping[this.selectedSource]
    this.router.navigate(['/heatwatch/heatwave/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'HEATWAVE';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  toggleSchoolCheckbox(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isChecked = checkbox.checked;
    if (!this.enableSchoolAlert) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isChecked = (event.target as HTMLInputElement).checked;
    }
    this.gisUtils.schoolCheckBoxClicked.next(this.isChecked);
    this.isCheckedAnganwadi = false
    this.isCheckedHealthCare = false
    this.gisUtils.CheckBoxAngaClicked.next(false)
    this.gisUtils.CheckBoxHealthCareClicked.next(false);
  }

  toggleCheckboxAnganwadi(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedAnganwadi = checkbox.checked;
    if (!this.enableAnganwadi) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isCheckedAnganwadi = (event.target as HTMLInputElement).checked;
    }
    this.gisUtils.CheckBoxAngaClicked.next(this.isCheckedAnganwadi);
    this.isChecked = false
    this.isCheckedHealthCare = false
    this.gisUtils.schoolCheckBoxClicked.next(false);
    this.gisUtils.CheckBoxHealthCareClicked.next(false);

  }

  toggleCheckboxHealthCare(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isCheckedHealthCare = checkbox.checked;
    if (!this.enableHealthCare) {
      event.preventDefault();
      // this.showMessage = true;
    } else {
      // this.showMessage = false;
      this.isCheckedHealthCare = (event.target as HTMLInputElement).checked;
    }
    this.gisUtils.CheckBoxHealthCareClicked.next(this.isCheckedHealthCare);
    this.isCheckedAnganwadi = false
    this.isChecked = false
    this.gisUtils.CheckBoxAngaClicked.next(false);
    this.gisUtils.schoolCheckBoxClicked.next(false);
  }

  showMessage(type) {
    if (!this.enableSchoolAlert || !this.enableAnganwadi || !this.enableHealthCare) {
      this.toastr.info("Go to Block Level for " +  type)
    }
  }

}
